import s from './LocationList.module.scss';
import LocationCard from '../../components/LocationCard/LocationCard';
import { Helmet } from 'react-helmet-async';

const LocationList = () => {
  return (
    <>
      <Helmet>
        <title>ケアンズ以外のツアー</title>
        <meta property="og:title" content="ケアンズ以外のツアー" />
        <meta property="og:image" content={`${process.env.REACT_APP_URL}/og-image.png`} />
        <meta property="og:url" content={`${process.env.REACT_APP_URL}/categories/location`} />
        <meta name="description" content="自社ツアーやオプショナルツアーも予約できます！" />
        <meta property="og:description" content="自社ツアーやオプショナルツアーも予約できます！" />
        <meta property="og:type" content="article" />

      </Helmet>
    <div className={s.root}>
      <div className={s.titleContainer}>
        <div className={s.verticalLine}></div>
        <h2>ケアンズ以外のツアー</h2>
      </div>
      <LocationCard />
    </div>
    </>
  );
};

export default LocationList;
